import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CheckoutB2BRootModule } from '@spartacus/checkout/b2b/root'
import {
  checkoutTranslationChunksConfig,
  checkoutTranslationsDe,
  checkoutTranslationsEn,
  checkoutTranslationsJa,
  checkoutTranslationsZh
} from '@spartacus/checkout/base/assets'
import {
  CHECKOUT_FEATURE,
  CheckoutDeliveryModeEventListener,
  CheckoutRootModule
} from '@spartacus/checkout/base/root'
import { CheckoutScheduledReplenishmentRootModule } from '@spartacus/checkout/scheduled-replenishment/root'
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core'
import { PageLayoutComponent } from '@spartacus/storefront'
import { EbAuthGuard } from '../../../features/auth/guards/eb-auth.guard'
import { EbCheckoutDeliveryModeEventListener } from '../../../features/checkout/events/eb-checkout-delivery-mode-event.listener'
import { EbCheckoutEntryGuard } from '../../../features/checkout/guards/eb-checkout-entry.guard'

@NgModule({
  declarations: [],
  imports: [
    CheckoutRootModule,
    CheckoutB2BRootModule,
    CheckoutScheduledReplenishmentRootModule,
    RouterModule.forChild([
      {
        path: 'checkout',
        canActivate: [EbAuthGuard, EbCheckoutEntryGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'checkout' }
      }
    ])
  ],
  providers: [
    EbCheckoutDeliveryModeEventListener,
    {
      provide: CheckoutDeliveryModeEventListener,
      useExisting: EbCheckoutDeliveryModeEventListener
    },
    provideConfig({
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () =>
            import('../../../features/checkout/eb-checkout.module').then(m => m.EbCheckoutModule)
        }
      }
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {
          en: checkoutTranslationsEn,
          ja: checkoutTranslationsJa,
          de: checkoutTranslationsDe,
          zh: checkoutTranslationsZh
        },
        chunks: checkoutTranslationChunksConfig
      }
    } as I18nConfig)
  ]
})
export class CheckoutFeatureModule {}
